export type PrimaryDestinationId = "home" | "agenda" | "vehicles" | "clients" | "sales" | "more";
export type NavigationMode = "essential" | "advanced";

const advancedDestinations = [
  "/app/documentos",
  "/app/inteligencia",
  "/app/configuracion",
] as const;

export function isPrimaryDestinationActive(
  id: PrimaryDestinationId,
  pathname: string,
  search: string,
  mode: NavigationMode,
): boolean {
  const view = new URLSearchParams(search).get("view");
  if (id === "home") return pathname === "/app";
  if (id === "agenda") return pathname.startsWith("/app/agenda");
  if (id === "vehicles") return pathname.startsWith("/app/stock");
  if (id === "clients") return pathname === "/app/leads" && view !== "ventas" && view !== "canales";
  if (id === "sales") return pathname.startsWith("/app/ventas") || (pathname === "/app/leads" && view === "ventas");
  if (pathname.startsWith("/app/mas")) return true;
  return mode === "essential" && advancedDestinations.some((destination) => pathname.startsWith(destination));
}

/** En móvil, Funciones representa también las secciones sin acceso inferior propio. */
export function isMobileDestinationActive(
  id: PrimaryDestinationId,
  pathname: string,
  search: string,
  mode: NavigationMode,
): boolean {
  if (id === "clients" && isPrimaryDestinationActive("sales", pathname, search, mode)) return true;
  if (id !== "more") return isPrimaryDestinationActive(id, pathname, search, mode);
  return pathname.startsWith("/app/") && !(["home", "agenda", "vehicles", "clients", "sales"] as const)
    .some((destination) => isPrimaryDestinationActive(destination, pathname, search, mode));
}
